import global from '../../global'

export default {
    // bgcolor: 'info.light',
    // color: 'info.contrastText',
    fontSize: 'body1.fontSize',
    padding: global.mainCard.padding,
    bgcolor: 'rgba(255,255,255,.7)',
    margin: '30px 0',
}